import React from 'react'
import { Container } from 'react-bootstrap'

function NotFound() {
  return (
    <Container className='text-center'>
      <h1 className='display-1 fw-bold'>404</h1>
      <p>Oops Not Found !</p>
    </Container>
  )
}

export default NotFound